import { useAppActivity } from "@/contexts/AppActivityContext";

export const useActivityOffset = () => {
  const { activeActivity, activeMedia } = useAppActivity();
  const activityHeight = activeActivity ? 44 : 0;
  const mediaHeight = activeMedia ? 36 : 0;
  return activityHeight + mediaHeight;
};
